const getters = {
    sideBar: state => state.app.sideBar,
    menus: state => state.app.routerView,
    token: state => state.user.token,
    account: state => state.user.account,
    roles: state => state.user.roles,
    name: state => state.user.name,
    userName: state => state.user.userName,
    stockLoading: state => state.stock.stockLoging
}
export default getters
